export class cOrderAgain {
  constructor() {
    const button = document.querySelector('.order-again .button') as HTMLAnchorElement;
    button.addEventListener('click', () => {
      sessionStorage.setItem('c-gtag-pending', JSON.stringify(window.cOrderAgainData));
    });
  }
}